import { z } from "zod";

// Terminal status of a staged per-page artifact (capture/screenshot promotion).
export const PAGE_ANALYSIS_STATUSES = ["completed", "failed"] as const;
export const PAGE_ANALYSIS_STATUS = {
  COMPLETED: "completed",
  FAILED: "failed",
} as const satisfies Record<string, PageAnalysisStatus>;
export const PageAnalysisStatusSchema = z.enum(PAGE_ANALYSIS_STATUSES);
export type PageAnalysisStatus = z.infer<typeof PageAnalysisStatusSchema>;
